import type { CompanyV2 } from "./types";

/**
 * Pick one company out of the authenticated list (`GET /company/profile/:id`).
 *
 * It exists because that list — not the public DTO of `GET /company/:id` — is
 * the only read that carries `invoice_email` / `invoice_address` /
 * `invoice_vat` and the caller's `role`. A surface that needs those has to
 * reach them through the list, and every such surface would otherwise write
 * the same `.find()` with the same `undefined` handling.
 *
 * Returns `undefined` for a missing list as well as a missing id, so a caller
 * can seed from it before the query resolves without branching first.
 */
export const selectCompanyById = (
  companies: CompanyV2[] | undefined,
  companyId: string | undefined,
): CompanyV2 | undefined => {
  if (!companies || !companyId) return undefined;
  return companies.find((company) => company.id === companyId);
};
